"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjectOpcodeTemplates = getObjectOpcodeTemplates;
function getObjectOpcodeTemplates() {
    return `
                        // Object/Property Operations
                        case opMap[70]: { // GET_PROP
                            let obj = stack.pop();
                            let prop = constants[arg];
                            // Validate object to provide meaningful error instead of exposing VM internals
                            if (obj === null || obj === undefined) {
                                throw new TypeError("Cannot read property '" + prop + "' of " + obj);
                            }
                            stack.push(obj[prop]);
                            pc++;
                            break;
                        }

                        case opMap[71]: { // SET_PROP
                            let val = stack.pop();
                            let obj = stack.pop();
                            let prop = constants[arg];
                            // Validate object to provide meaningful error instead of exposing VM internals
                            if (obj === null || obj === undefined) {
                                throw new TypeError("Cannot set property '" + prop + "' of " + obj);
                            }
                            obj[prop] = val;
                            stack.push(val);
                            pc++;
                            break;
                        }

                        case opMap[72]: { // GET_COMPUTED
                            let prop = stack.pop();
                            let obj = stack.pop();
                            // Validate object to provide meaningful error instead of exposing VM internals
                            if (obj === null || obj === undefined) {
                                throw new TypeError("Cannot read property '" + prop + "' of " + obj);
                            }
                            stack.push(obj[prop]);
                            pc++;
                            break;
                        }

                        case opMap[73]: { // SET_COMPUTED
                            // Stack before: [obj, key, value]
                            // Stack after: [value]
                            let val = stack.pop();   // Pop value
                            let prop = stack.pop();  // Pop key
                            let obj = stack.pop();   // Pop object
                            // Validate object to provide meaningful error instead of exposing VM internals
                            if (obj === null || obj === undefined) {
                                throw new TypeError("Cannot set property '" + prop + "' of " + obj);
                            }
                            obj[prop] = val;
                            stack.push(val);
                            pc++;
                            break;
                        }

                        case opMap[74]: { // DELETE_PROP
                            let prop;
                            let obj;
                            if (arg !== undefined) {
                                // Named property: obj.prop - get property name from constants
                                obj = stack.pop();
                                prop = constants[arg];
                            } else {
                                // Computed property: obj[key] - get property from stack
                                prop = stack.pop();
                                obj = stack.pop();
                            }
                            let result = delete obj[prop];
                            stack.push(result);
                            pc++;
                            break;
                        }

                        case opMap[75]: { // GET_GLOBAL
                            let name = constants[arg];
                            let value;
                            let globalObj = (typeof globalThis !== 'undefined' ? globalThis : (typeof window !== 'undefined' ? window : global));

                            // Use 'in' operator instead of hasOwnProperty for better performance
                            if (name in {vmGlobalsName}) {
                                // Check VM globals first (for obfuscator-created globals)
                                value = {vmGlobalsName}[name];
                            } else if ({vmModuleVarsName} && name in {vmModuleVarsName}) {
                                // Check module-scoped variables (require, module, exports, __filename, __dirname)
                                value = {vmModuleVarsName}[name];
                            } else if (name in globalObj) {
                                // BUG FIX #589: Only access global if it actually exists
                                // Fall back to actual global object
                                value = globalObj[name];
                            } else {
                                // BUG FIX #589: Throw ReferenceError for undefined variables
                                // In JavaScript, accessing an undeclared variable throws ReferenceError
                                throw new ReferenceError(name + ' is not defined');
                            }
                            stack.push(value);
                            pc++;
                            break;
                        }

                        case opMap[76]: { // SET_GLOBAL
                            let val = stack.pop();
                            let name = constants[arg];
                            // Update in the appropriate location:
                            // - If it exists in module vars (module, exports, etc.), update there
                            // - Otherwise update in VM globals
                            if ({vmModuleVarsName} && name in {vmModuleVarsName}) {
                                {vmModuleVarsName}[name] = val;
                            } else {
                                {vmGlobalsName}[name] = val;
                            }
                            stack.push(val);
                            pc++;
                            break;
                        }

                        case opMap[77]: { // NEW_OBJECT
                            stack.push({});
                            pc++;
                            break;
                        }

                        case opMap[78]: { // GET_OPTIONAL
                            let obj = stack.pop();
                            let prop = constants[arg];
                            // Optional chaining: if obj is null/undefined, return undefined
                            if (obj === null || obj === undefined) {
                                stack.push(undefined);
                            } else {
                                stack.push(obj[prop]);
                            }
                            pc++;
                            break;
                        }

                        case opMap[79]: { // IN
                            // 'in' operator: checks if property exists in object
                            // Stack before: [property, object]
                            // Stack after: [boolean]
                            let inObj = stack.pop();
                            let inProp = stack.pop();
                            stack.push(inProp in inObj);
                            pc++;
                            break;
                        }

                        case opMap[81]: { // OBJECT_SPREAD
                            // Object spread: merge properties from source to target
                            // Stack before: [target, source]
                            // Stack after: [target] (with properties from source merged)
                            let spreadSource = stack.pop();
                            let spreadTarget = stack[stack.length - 1]; // Peek at target (don't pop)
                            // Use Object.assign to merge properties
                            if (spreadSource !== null && spreadSource !== undefined) {
                                Object.assign(spreadTarget, spreadSource);
                            }
                            pc++;
                            break;
                        }

                        case opMap[82]: { // GET_COMPUTED_OPTIONAL
                            // Optional chaining with computed property: obj?.[expr]
                            // Stack before: [object, property]
                            // Stack after: [value or undefined]
                            let optProp = stack.pop();
                            let optObj = stack.pop();
                            // If object is null/undefined, return undefined
                            if (optObj === null || optObj === undefined) {
                                stack.push(undefined);
                            } else {
                                stack.push(optObj[optProp]);
                            }
                            pc++;
                            break;
                        }
    `;
}
